import React from 'react';
import { Row, Square } from '@grubhubprod/gh-cookbook-react';

export interface TieredAccountRowProps {
  children: React.ReactNode;
}

export const TieredAccountRow: React.FC<TieredAccountRowProps> = ({
  children,
}) => {
  return (
    <Square borderBottom="1px solid" borderColor="lightLine">
      <Row role="row">{children}</Row>
    </Square>
  );
};
